import React from 'react'
import { AssumedInjuryV2 } from 'store/ducks/report/types'
import { getSvgPaths } from './bodyPartSVGMapping'

interface BodyMapOverlayProps {
  injuries: AssumedInjuryV2[]
  className?: string
  style?: React.CSSProperties
}

export const BodyMapOverlay: React.FC<BodyMapOverlayProps> = ({
  injuries,
  className,
  style
}) => {
  const allSvgPaths = new Set(injuries.flatMap(injury => getSvgPaths(injury)))

  return (
    <div
      className={`body-map-overlay ${className || ''}`}
      style={{
        position: 'relative',
        display: 'inline-block',
        maxWidth: '300px',
        ...style
      }}
    >
      {/* Base body image */}
      <img
        src="/assets/BodyParts/body.jpg"
        alt="Human body"
        style={{
          width: '100%',
          height: 'auto',
          display: 'block'
        }}
      />

      {/* All SVG overlays */}
      {Array.from(allSvgPaths).map((svgPath, index) => (
        <img
          key={index}
          src={svgPath}
          alt="Injury overlay"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            pointerEvents: 'none'
          }}
          onError={e => {
            // Hide broken images
            e.currentTarget.style.display = 'none'
            console.warn(`Could not load SVG overlay: ${svgPath}`)
          }}
        />
      ))}
    </div>
  )
}

export default BodyMapOverlay
